import { render } from "./campus_notice.vue?vue&type=template&id=1e4190b6"
import script from "./campus_notice.vue?vue&type=script&lang=js"
export * from "./campus_notice.vue?vue&type=script&lang=js"

import "./campus_notice.vue?vue&type=style&index=0&id=1e4190b6&lang=css"

import exportComponent from "C:\\Users\\home\\Documents\\GitHub\\childu_usersite\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__